//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
import cmBlank from '@/components/cmBlank.vue'

export default {
  name: 'barOrder',
  components: {
      cmBlank
  },
  data () {
    return {
      id:0,
      blankShow:true,
      popUp:false,
      code:'',
      order:{
        factory_wash_code:'',
        log:[],
        factory:[],
        community:{}
      },
      number:'',
    }
  },
  created(){
    this.config();
  },
  mounted(){
    this.resetScrollTop();
    this.code = this.$route.params.code;
    if(this.code){
      this.getOrder();
    }
    // this.id = Number(this.$route.params.id);
    // this.changePop();
  
  },
  activated(){
    this.resetScrollTop();
  },
  methods:{
    resetScrollTop(){
      this.$nextTick(()=>{
        window.scrollTo(0,0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        setTimeout(()=>{
          window.scrollTo(0,0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        },100);
      });
    },
     searchOrder(orderNo){
        this.$router.push({name:'searchOrder',params:{code:orderNo}})
    },
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = that.$func.parseScanResult(res.resultStr);
                    that.code = that.$func.parseScanResult(res.resultStr);
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    showPic(urls,url){
      wx.previewImage({
        current: url ? url : urls[0], // 当前显示图片的 http 链接
        urls: urls // 需要预览的图片 http 链接列表
      });
    },
    getOrder(){
      let that = this;
      this.code = this.$func.normalizeScanValue(this.code);
      if(!this.code){
        that.$func.showToast('衣物条码无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      this.$api.barOrder({code:this.code}).then((res)=>{
        if(res){
          that.order = res.data;
          this.blankShow = false;
          that.$func.endLoading();
        } 
      })  
    },
    submit(){
      let that = this;
      if(!this.number){
        that.$func.showToast('请输入挂点');
        return ;
      }
      if(!this.order.factory_wash_code){
        that.$func.showToast('输入衣物条码或扫条码');
        return ;
      }
      this.$api.communityUp({code:this.order.factory_wash_code,number:that.number}).then((res)=>{
        if(res){
           that.$func.showToast('已上挂');
           that.popUp = false;
        } 
      })  
    },
    lightUpStrip(item){
      if(!item.strip_code){
        this.$func.showToast('灯条编码为空');
        return ;
      }
      this.$func.startLoading('点亮中。。。');
      this.$api.lightUpStrip({strip_code:item.strip_code}).then((res)=>{
        if(res){
          this.$func.showToast('已点亮5秒');
        }
        this.$func.endLoading();
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/upClotheYizhuanjia.vue